import Choices from '../vendor/choices/choices';
import { addClass } from '../tools/DOM';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-select')];

	const OPTIONS = {
		searchEnabled: false,
		searchChoices: false,
		shouldSort: false,
	};


	const init = (element) => {
		const select = new Choices(element, OPTIONS);
		const placeholder = select.itemList.element.querySelector('.choices__placeholder');
		const id = select.passedElement.element.getAttribute('id');
		const label = document.querySelector(`[for='${id}']`);


		if (!placeholder) {
			addClass(label, 'is-active');
		}

		select.passedElement.element.addEventListener('choice', (event) => {
			const isPlaceholder = event.detail.choice.placeholder;

			if (!isPlaceholder) {
				addClass(label, 'is-active');
			}
		});

		return select;
	};


	elements.forEach(init);
};
